/**
 * @file
 * Expand collapse footer blocks.
 */

const $context = $('.footer-menu-block, .footer-contact-block', context);
$context.once('footer-collapse-expand-blocks').each((index, el) => {
  const $block = $(el);
  const $title = $block.find('.footer-title');

  $title.click(() => $block.toggleClass('is-open'));
});
